/**
 * Defines travel info types.
 */
export enum TravelInfoType {
  MoreInformation = 'MoreInformation',
  FreeText = 'FreeText',
  Emergency = 'Emergency',
}
